export const requestTestOccurrenceTreeOptions = {
  withNewFailure: true,
  withMetadataCount: true,
  withNextFixed: true,
  withMuteInfo: true,
  withInvestigationInfo: true,
  withInvocationsCounters: true,
}
export const STOP_EXPANDING_EVENT = 'expanding:STOP'
export const TESTS_TREE_EXPAND_ALL_EVENT = 'testsTreeExpandAll'

export const DEFAULT_EXPANSION_STEP_SIZE = 100
